import React, { useEffect, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { Link } from "react-router-dom";
import Message from "./LoadingError/Error";
import { useDispatch, useSelector } from "react-redux";
import { createProductReview, listProductDetails } from "../redux/Actions/ProductActions";
import { FaStar } from "react-icons/fa";
import Loading from "./LoadingError/Loading";
import { toast } from "react-toastify";
import { PRODUCT_CREATE_REVIEW_RESET } from "../redux/Constants/ProductConstants";
import LoadingSmall from "./LoadingError/LoadingSmall";
function StarRating({ value = 0, onChange, max = 5, size = 24 }) {
    const [hovered, setHovered] = useState(0);

    return (
        <div
            role="radiogroup"
            aria-label="Đánh giá"
            className="flex items-center gap-2"
            onMouseLeave={() => setHovered(0)}
        >
            {Array.from({ length: max }, (_, i) => i + 1)?.map((star) => {
                const active = (hovered || value) >= star;
                return (
                    <button
                        key={star}
                        type="button"
                        role="radio"
                        aria-checked={value === star}
                        aria-label={`${star} sao`}
                        onClick={() => onChange(star)}
                        onMouseEnter={() => setHovered(star)}
                        onKeyDown={(e) => {
                            if (e.key === "ArrowRight") onChange(Math.min(max, (value || 0) + 1));
                            if (e.key === "ArrowLeft") onChange(Math.max(1, (value || 0) - 1));
                        }}
                        className={`cursor-pointer transition-transform focus:outline-none  rounded ${active ? "text-yellow-500" : "text-gray-300"
                            }`}
                        style={{ lineHeight: 0 }}
                    >
                        <FaStar />
                    </button>
                );
            })}
        </div>
    );
}
const ToastObjects = {
    pauseOnFocusLoss: false,
    draggable: false,
    pauseOnHover: false,
    autoClose: 3000,
};
export default function ReviewFormRHF({
    productId
}) {
    const dispatch = useDispatch();
    const userLogin = useSelector((state) => state.userLogin);
    const { userInfo } = userLogin;
     // Chưa đăng nhập → nhắc đăng nhập
   
    const productReviewCreate = useSelector((state) => state.productReviewCreate);
    const {
        loading: loadingCreateReview,
        error: errorCreateReview,
        success: successCreateReview,
    } = productReviewCreate;

  
    
    const {
        register,
        handleSubmit,
        reset, control,
        formState: { errors, isSubmitting },
    } = useForm({
        defaultValues: {
            rating: "5",   // "" nếu chưa chọn
            comment: "",
        },
        mode: "onTouched",
    });
    useEffect(() => {
        if (successCreateReview) {
          toast.success("Review Submitted", ToastObjects);
          reset({
            comment:""
          })
          dispatch({ type: PRODUCT_CREATE_REVIEW_RESET });
          dispatch(listProductDetails(productId));
        }
     
      }, [dispatch,  successCreateReview]);
    const submitHandler = handleSubmit(async (values) => {
        dispatch(
            createProductReview(productId, {
                rating: values.rating,
                comment: values.comment,
            })
        );
    });



    if (!userInfo) {
        return (
            <div className="my-3">
                <Message variant={"alert-warning"}>
                    Vui lòng{" "}
                    <Link to="/login">
                        "<strong>Đăng nhập</strong>"
                    </Link>{" "}
                    để viết bình luận
                </Message>
            </div>
        );
    }

    // Đã đăng nhập → hiển thị form RHF
    return (

        <>
            { errorCreateReview ? (
                <Message variant="danger">{errorCreateReview}</Message>
            ) : (

                <form onSubmit={handleSubmit(submitHandler)}>
                    {/* Đánh giá */}
                    <div className="my-4">
                        <strong>Đánh giá</strong>
                        <Controller
                            name="rating"
                            control={control}
                            rules={{
                                required: "Vui lòng chọn mức đánh giá",
                                validate: (v) => (v >= 1 && v <= 5) || "Giá trị không hợp lệ",
                            }}
                            render={({ field }) => (
                                <StarRating
                                    value={Number(field.value) || 0}
                                    onChange={(v) => field.onChange(Number(v))}
                                />
                            )}
                        />
                        {errors.rating && (
                            <p className="text-xs text-red-600 mt-1">{errors.rating.message}</p>
                        )}
                    </div>

                    {/* Bình luận */}
                    <div className="my-4">
                        <strong>Bình luận</strong>
                        <textarea
                            rows={3}
                            className="w-full bg-gray-100 p-3 mt-2 border-0 rounded outline-none focus:ring-2 focus:ring-indigo-500"
                            {...register("comment", {
                                required: "Vui lòng nhập bình luận",
                                minLength: { value: 5, message: "Bình luận tối thiểu 5 ký tự" },
                            })}
                        />
                        {errors.comment && (
                            <p className="text-xs text-red-600 mt-1">{errors.comment.message}</p>
                        )}
                    </div>

                    {/* Gửi */}
                    <div className="my-3">
                        <button
                            type="submit"
                            disabled={loadingCreateReview || isSubmitting}
                            className="w-full bg-black border-0 p-3 rounded text-white hover:bg-gray-900 disabled:opacity-60 flex items-center justify-center"
                        >
                            {loadingCreateReview || isSubmitting ? <div className="flex gap-2 w-full items-center justify-center"><span>Đang gửi... </span><LoadingSmall  className={"h-5 w-5 p-0"}/> </div> : "Gửi"} 
                        </button>
                    </div>
                </form>)
            }
        </>
    );
}
